import { CommonImage } from '@porterin/feature/src/shared/types/CommonVM';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';

import styles from '../styles/EstimateLayout.module.scss';

interface EstimateLayoutProps {
  title: string;
  sub_title: string;
  title_mobile: string;
  sub_title_mobile?: string;
  children: React.ReactNode;
  close_modal: () => void;
  className?: string;
  close_icon: CommonImage;
}

function EstimateLayout({
  title,
  sub_title,
  title_mobile,
  sub_title_mobile,
  children,
  close_modal,
  className = '',
  close_icon,
}: Readonly<EstimateLayoutProps>): React.ReactElement {
  return (
    <div className={`${styles['estimate-layout-container']} ${className}`}>
      <section className={styles['title-container']}>
        <p className={styles['title']}>{title}</p>
        <p className={styles['sub-title']}>{sub_title}</p>
        <p className={styles['title-mobile']}>{title_mobile}</p>
        {sub_title_mobile !== undefined && (
          <p className={styles['sub-title-mobile']}>{sub_title_mobile}</p>
        )}
      </section>
      <section className={styles['form-container']}>{children}</section>
      <button
        className={styles['close-modal-button']}
        onClick={() => close_modal()}
      >
        <NextImageV2
          src={close_icon.path}
          height={24}
          width={24}
          alt={close_icon.alt_text}
          quality={100}
        />
      </button>
    </div>
  );
}

export default EstimateLayout;
